// extracted by mini-css-extract-plugin
module.exports = {"correct":"Option_correct__2EtMx","wrong":"Option_wrong__1hRVE"};